/* eslint-disable consistent-return */
import Slider from '../Slider';

class Carousel extends Slider {
  constructor(options) { /* eslint-disable-line */
    super(options);
  }

  move(index, direction) {
    if (index < 0 || index === this.slideItems.length) return false;

    const delta = (this.slideItems[0].offsetWidth + this.margin)
     * index * direction + this.calcPaddingToCenter();
    this.slideItems[this.state.current].classList.remove('slider__item--active');

    this.stage.style.transform = `translate3d(${delta}px, 0px, 0px)`;
    this.stage.style.webkitTransform = `translate3d(${delta}px, 0px, 0px)`;

    this.state.current = index;

    if (this.state.current === this.slideItems.length - 1) {
      this.nextBtn.setAttribute('disabled', true);
    } else if (this.nextBtn.hasAttribute('disabled')) this.nextBtn.removeAttribute('disabled', true);

    if (this.state.current === 0) {
      this.prevBtn.setAttribute('disabled', true);
    } else if (this.prevBtn.hasAttribute('disabled')) this.prevBtn.removeAttribute('disabled', true);
  }
}

export default Carousel;
